import {ValueObject} from '@s-ui/domain'

export class SubscriptionModelsListValueObject extends ValueObject {
  /**
   * @param {Array<SubscriptionModelValueObject>} items
   * */

  getItems() {
    return this._items
  }
}
